export enum RCEventType {
  start = 'rc-call-start-notify',
  active = 'rc-active-call-notify',
  end = 'rc-call-end-notify',
  messageUpdate = 'rc-message-updated-notify',
  popupWindow = 'rc-popup-window',
}

export enum RCDirection {
  in = 'Inbound',
  out = 'Outbound',
}

export interface RCEvent {
  type: RCEventType;
}

export interface RCCallStart extends RCEvent {
  call: {
    id: string;
    direction: RCDirection;
    to: string;
    from: string;
    fromNumber: string;
    startTime: number;
    partyData: {
      sessionId: string;
    };
  };
}

export interface RCCallActive extends RCEvent {
  call: {
    direction: RCDirection;
    to: { phoneNumber: string };
    from: { phoneNumber: string };
    fromNumber: string;
    telephonyStatus: 'Ringing' | 'CallConnected';
  };
}

export interface RCMessageUpdate extends RCEvent {
  message: {
    to: { extensionNumber?: string; extensionId?: string; phoneNumber?: string }[];
    from: { extensionNumber: string; extensionId: string; phoneNumber?: string };
    subject: string;
    direction: RCDirection;
    type?: string;
  };
}

export interface RCCallEnd extends RCEvent {
  call: {
    id: string;
    direction: RCDirection;
    to: string;
    from: string;
    fromNumber: string;
    startTime: number;
    endTime: number;
    partyData: {
      sessionId: string;
    };
  };
}

export interface RCPopupWindow extends RCEvent {
  minimized: boolean;
}
